export default __webpack_public_path__ + "static/quote-video-2-static-9f5e78a02a6476909905841ddb5c4c23.png";